<template>
    <div class="">
        <div v-if="reservation.billing" class="row">
            <div class="col-sm-4 col-lg-3">
                <label :class="{ 'color-6': $v.reservation.billing.details.vat.$invalid }">
                    VAT Number
                </label>

                <input
                    type="text"
                    class="full mb-3"
                    v-model="reservation.billing.details.vat"
                    :disabled="readOnly"
                    @input="changed()"
                >
            </div>

            <div class="col-sm-4 col-lg-3">
                <label :class="{ 'color-6': $v.reservation.billing.details.city.$invalid }">
                    City
                </label>

                <input
                    type="text"
                    class="full mb-3"
                    v-model="reservation.billing.details.city"
                    :disabled="readOnly"
                    @input="changed()"
                >
            </div>

            <div class="col-sm-4 col-lg-3">
                <label>
                    Postal Code
                </label>

                <input
                    type="text"
                    class="full mb-3"
                    v-model="reservation.billing.details.postalCode"
                    :disabled="readOnly"
                    @input="changed()"
                >
            </div>

            <div class="col-sm-4 col-lg-3 mb-3 mb-lg-0">
                <label>
                    Country
                </label>

                <country-picker :openDirection="'bottom'" :selectedCountryValue="selectedCountry" :disabled="false" :allowEmpty="false" @input="updateCountry($event)"></country-picker>
            </div>

            <div class="col-sm-6 col-lg-6">
                <label :class="{ 'color-6': $v.reservation.billing.details.businessName.$invalid }">
                    Billing name
                </label>
                
                <input
                    type="text"
                    class="full mb-3"
                    v-model="reservation.billing.details.businessName"
                    :disabled="readOnly"
                    @input="changed()"
                >
            </div>

            <div class="col-sm-6 col-lg-6">
                <label :class="{ 'color-6': $v.reservation.billing.details.address.$invalid }">
                    Address
                </label>

                <input
                    type="text"
                    class="full mb-3"
                    v-model="reservation.billing.details.address"
                    :disabled="readOnly"
                    @input="changed()"
                >
            </div>

            <div class="col-sm-12 text-right">
                <button class="btn tertiary" @click="prePopulateBillingDetails()">Auto Fill</button>
            </div>
        </div>

        <!-- Errors -->
        <div class="row" v-if="$v.reservation.billing.details.$invalid" >
            <div class="col-sm-12">
                <div class="color-6 bold fs-small">
                    <div v-if="!$v.reservation.billing.details.vat.maxLength">VAT Number field can not be longer than {{$v.reservation.billing.details.vat.$params.maxLength.max}} characters</div>
                    <div v-if="!$v.reservation.billing.details.city.maxLength">City field can not be longer than {{$v.reservation.billing.details.city.$params.maxLength.max}} characters</div>
                    <div v-if="!$v.reservation.billing.details.businessName.maxLength">Billing name  field can not be longer than {{$v.reservation.billing.details.businessName.$params.maxLength.max}} characters</div>
                    <div v-if="!$v.reservation.billing.details.address.maxLength">Address field can not be longer than {{$v.reservation.billing.details.address.$params.maxLength.max}} characters</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import { maxLength } from 'vuelidate/lib/validators'

import extendedVSelect from '@/extends/vue-select'
import CountryPicker from '@/tools/CountryPicker'

export default {
    created() {
        // Set the correct selected country
        this.setSelectedCountry(this.reservation.billing.details.country);
    },
    data() {
        return {
            selectedCountry: null,
        }
    },
    props: {
        reservation: {
            type: Object
        },
        showInvoiceBtn: {
            type: Boolean,
            default: true,
        },
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    validations() {
        return{
            reservation:{
                billing:{
                    details: this.validationLimits
                }
            }
        }
    },
    computed:{
        ...mapGetters([
            'getCountries',
            'getCompanySettings',
            'getIsSavingReservation',
            'getIsCreatingInvoice',
            'getShowInvoiceOption',
            'getInvoiceSystemIntegration'
        ]),
        validationLimits() {
            return {
                "vat":{
                    maxLength: maxLength(this.getInvoiceSystemIntegration.integrationSpecifics && this.getInvoiceSystemIntegration.integrationSpecifics.validations.vat
					? this.getInvoiceSystemIntegration.integrationSpecifics.validations.vat
					: 999999)
                },
                "city":{
                    maxLength: maxLength(this.getInvoiceSystemIntegration.integrationSpecifics && this.getInvoiceSystemIntegration.integrationSpecifics.validations.location
					? this.getInvoiceSystemIntegration.integrationSpecifics.validations.location
					: 999999)
                },
                "businessName":{
                    maxLength: maxLength(this.getInvoiceSystemIntegration.integrationSpecifics && this.getInvoiceSystemIntegration.integrationSpecifics.validations.name
					? this.getInvoiceSystemIntegration.integrationSpecifics &&this.getInvoiceSystemIntegration.integrationSpecifics.validations.name
					: 999999)
                },
                "address":{
                    maxLength: maxLength(this.getInvoiceSystemIntegration.integrationSpecifics && this.getInvoiceSystemIntegration.integrationSpecifics.validations.address
					? this.getInvoiceSystemIntegration.integrationSpecifics.validations.address
					: 999999)
                },
            }
        },
        compShowInvoiceBtn() {
            return this.getShowInvoiceOption? this.getShowInvoiceOption : false;
        },
        unsavedChanges() {
            let output = false;

            if (this.reservation.updateFlags) {
                for (var updateFlag in this.reservation.updateFlags) {
                    if (updateFlag == true) {
                        output = true;
                    }
                }
            }

            return output;
        },
        isSavingReservation () {
            return this.getIsSavingReservation;
        }
    },
    methods: {
        prePopulateBillingDetails() {
            // Billing name
            this.reservation.billing.details.businessName = this.reservation.customer.name;

            // Country
            this.setSelectedCountry(this.reservation.customer.country);
        },
        changed() {
            this.$set(this.reservation.updateFlags, 'billing', true);
        },
        updateCountry(e) {
            this.selectedCountry = e;
            this.reservation.billing.details.country = e.id;
        },
        setSelectedCountry(countryId) {
            this.selectedCountry = this.getCountries.filter(country => {
                return country.id == countryId;
            })[0];
        },
        startCreateInvoice() {
            if (this.unsavedChanges) {
                this.$dialog.alert('There are unsaved changes, you must save the reservation before invoicing.', {okText: 'OK'})
                .then(function () {})
                .catch(function () {});

                return false;
            }

            this.eventHub.$emit('editReservation_toggleCreateInvoice');
        }
    },
    components: {
        vSelect: extendedVSelect,
        CountryPicker
    },
    watch:{
        'reservation.billing.details.country': {
            handler(newVal, oldVal) {
                this.changed();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '../../../../../assets/scss/_variables';
    
    input{
        background-color: $lighter
    }
</style>



// WEBPACK FOOTER //
// BillingDetails.vue?92ef5022